export enum AntwoordType {

  Tekst = 1,
  Email = 2,
  Telefoon = 3,
  Datum = 4,
  Nummer = 5
}
